import commonFunc from "../../../common.func";
const mutations = {
    updateKycIncidents(state, { result, stateKey }) {
        const headers = result.resultHeaders || result.headers;
        state[stateKey].headers = [];
        state[stateKey].data = [];
        if (!headers || !headers.length) {
            return;
        }
        const entitiesWithAttributesLocalStorage = localStorage.entitiesWithAttributes;
        if (!entitiesWithAttributesLocalStorage) {
            return;
        }

        const entitiesWithAttributes = commonFunc.getCompressedItem('entitiesWithAttributes')
        const entityAttributesMap = {};
        const aliasToColumnKeyMap = {};
        for (const header of headers) {
            if (!entityAttributesMap[header.entityId]) {
                entityAttributesMap[header.entityId] = entitiesWithAttributes.find(t => t.id == header.entityId)?.attributeList ?? [];
            }
            const attribute = entityAttributesMap[header.entityId].find(t => t.id == header.attributeId);
            if (!attribute) {
                continue;
            }

            const columnKey = `${header.entityAlias}_${header.entityId}_${header.attributeId}`;
            aliasToColumnKeyMap[header.headerAlias] = columnKey;

            state[stateKey].headers.push({
                sortable: true,
                text: header.headerAlias,
                value: columnKey,
                datatype: attribute.datatype,
                columnName: columnKey,
                show: state[stateKey].columnVisibilityStatuses[columnKey] ?? true
            });
        }

        const queryResults = result.queryResults || (result.data && result.data.data) || [];
        const mappedData = queryResults.map(row => {
            const mappedRow = {};
            for (const [alias, colKey] of Object.entries(aliasToColumnKeyMap)) {
                if (row[alias] !== undefined) {
                    mappedRow[colKey] = row[alias];
                }
            }
            if (row.nodeEdgeUniqueValueMap) {
                const nodeRefs = row.nodeEdgeUniqueValueMap.nodeUniqueValueMap || [];
                mappedRow._nodeUniqueValueMap = nodeRefs;
                const nodeMap = (result.nodeEdgeMap && result.nodeEdgeMap.nodeMap) || {};
                for (let ni = 0; ni < nodeRefs.length; ni++) {
                    const node = nodeMap[nodeRefs[ni]];
                    if (node && node.properties && node.properties.response_code) {
                        mappedRow.responseCode = node.properties.response_code;
                        break;
                    }
                }
            }
            if (row.responseCode !== undefined) {
                mappedRow.responseCode = row.responseCode;
            }
            return mappedRow;
        });
        state[stateKey].data = mappedData;
        state[stateKey].pagination.totalRowCount = result.totalRowCount != null
            ? result.totalRowCount
            : queryResults.length;
        state[stateKey].responseCodeCounts = result.responseCodeCounts || {};
    },
    clearKycData(state, stateKey) {
        state[stateKey].data = [];
        state[stateKey].responseCodeCounts = {};
    },
    changeKycIncidentLoading(state, { isLoading, stateKey }) {
        state[stateKey].loading = isLoading;
    },
    changeKycSelectedIncidents(state, { value, stateKey }) {
        state[stateKey].selectedIncidents = value;
    },
    changeKycTableUniqueKey(state, { value, stateKey }) {
        state[stateKey].tableUniqueKey = value;
    },
    changeKycColumnVisibilityStatus(state, { columnKey, isVisible, stateKey }) {
        state[stateKey].columnVisibilityStatuses[columnKey] = isVisible;
    },
    changeKycTableOptions(state, { key, value, stateKey }) {
        state[stateKey].tableOptions[key] = value;
    }
}
export default mutations;
